<template>
  <li
    class="fb fb-col bg-FFFFFF hidden"
    :class="[
      noPb ? '' : 'bd-radio-8 m-16-0 m-0-16 pt-12',
      noPbCross ? '' : 'p-0-16'
    ]"
  >
    <div class="relative" @click="handlerClickItem(cpShowStudent)">
      <studentHead
        :student-info="cpShowStudent"
        :class="[hasTag ? 'max-w-260' : '']"
        max-width="180px"
        :name-len="4"
        show-all-class
        tag-wrap
      >
        <div
          v-if="!noType && cpShowStudent.leaveTypeName"
          :slot="
            calStringLen(cpShowStudent.leaveTypeName) > 0
              ? 'block-tag'
              : 'inline-tag'
          "
          ><div
            class="inline-block border-171A1D c-171A1D-80 p-0-6 p-2-0 bd-radio-9999 text-center font-24"
            :class="[
              calStringLen(cpShowStudent.leaveTypeName) > 0 ? 'm-6-0' : 'ml-8'
            ]"
            >{{ cpShowStudent.leaveTypeName }}</div
          ></div
        >
      </studentHead>
      <div
        v-show="!noTime"
        class="font-28 p-0-16 c-171A1D-60 ml-32 pb-12"
        :class="[showbb ? 'bb' : '']"
      >
        <p>
          <span>开始时间：</span>
          <span v-if="+cpShowStudent.leaveDurationUnit === 2">{{
            cpShowStudent.localStartTime
          }}</span>
          <common-time
            v-else
            :time="cpShowStudent.startTime"
            format="YYYY.MM.DD hh:mm"
          ></common-time>
        </p>
        <p>
          <span>结束时间：</span>
          <span v-if="+cpShowStudent.leaveDurationUnit === 2">{{
            cpShowStudent.localEndTime
          }}</span>
          <common-time
            v-else
            :time="cpShowStudent.endTime"
            format="YYYY.MM.DD hh:mm"
          ></common-time>
        </p>
      </div>

      <leave-status
        border
        class="font-24 student-shrink-0 absolute leave-status"
        :status="cpShowStudent.approveStatus"
        :biz="biz"
      ></leave-status>
    </div>
    <md-list
      v-if="
        type !== 2 &&
        (allowLeaveBackCertificate
          ? cpShowStudent.backSchoolStatus > 0
          : cpShowStudent.backSchoolStatus > 1)
      "
      :class="[noPb ? 'ml-32' : '', showbb ? 'bb' : 'bt']"
      arrow
    >
      <md-list-item
        title="返校证明"
        @click="
          handlerClickList(
            cpShowStudent.backSchoolStatus,
            cpShowStudent.dingPersonId,
            cpShowStudent.leaveId
          )
        "
      >
        <span
          class="font-30"
          slot="description"
          :style="{
            color: BACK_SCHOOL_STATUS[+cpShowStudent.backSchoolStatus].color
          }"
          >{{
            BACK_SCHOOL_STATUS[+cpShowStudent.backSchoolStatus].content
          }}</span
        >
      </md-list-item>
    </md-list>
  </li>
</template>

<script>
import mixin from '@/mixin'
import leaveStatus from './leaveStatus'
import commonTime from '../commonTime'
import studentHead from '../studentHead'

import { BACK_SCHOOL_STATUS } from '@/utils/constUtils'
import { unitDayTime, calStringLen } from '@/utils/comUtils'
import {} from '@/utils/mcSdkUtils'

export default {
  mixins: [mixin],
  name: 'leaveListItem',
  components: { leaveStatus, commonTime, studentHead },
  props: {
    student: {
      type: Object,
      default: () => {}
    },
    biz: {
      type: String,
      default: 'list'
    },
    // 2: 修改或撤销请假列表
    type: {
      type: Number,
      default: 1
    },
    noPb: {
      type: Boolean,
      default: false
    },
    noPbCross: {
      type: Boolean,
      default: false
    },
    showbb: {
      type: Boolean,
      default: false
    },
    hasTag: {
      type: Boolean,
      default: false
    },
    noTime: {
      type: Boolean,
      default: false
    },
    noType: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      calStringLen,
      BACK_SCHOOL_STATUS,
      UNIT_TYPE: ['', 'startTime', 'localStartTime']
    }
  },
  computed: {
    cpShowStudent() {
      const _unitDayTime = unitDayTime(
        +this.student.startTime,
        +this.student.endTime,
        'YYYY.MM.DD hhmm'
      )
      return {
        ...this.student,
        gender: this.student.sex || this.student.gender,
        localStartTime: _unitDayTime[0] || '',
        localEndTime: _unitDayTime[1] || '',
        leaveTypeName:
          this.student.leaveTypeName +
          (this.student.subLeaveTypeName
            ? '-' + this.student.subLeaveTypeName
            : '')
      }
    },
    allowLeaveBackCertificate() {
      return this.$store.getters.allowLeaveBackCertificate
    }
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  async mounted() {
    await this.$store.dispatch('leaveBackConfigGet', {})
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    handlerClickItem(student) {
      this.$router.push({
        path: '/leave/detail',
        query: {
          leaveId: student.leaveId
        }
      })

      this.$emit('click', student)
    },
    handlerClickList(backSchoolStatus, studentDingIds, leaveId) {
      let url = '/leave/backdetail'
      //  返校证明状态 1：未上传 2：待审核 3：已通过 4：已拒绝 5: 已失效
      if (this.allowLeaveBackCertificate) {
        const _goBack =
          (this.curIsGuardian || this.isStudent) && backSchoolStatus === 1
        _goBack && (url = '/leave/back')
      }
      this.$emit('clickBack', url, studentDingIds, leaveId)
      this.mixinRouter(url, {
        studentDingIds,
        leaveId
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.leave-status {
  top: 50%;
  right: 0;
  transform: translateY(-50%);
}
</style>
